
// Import the functions needed from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore"; // THIS LINE FIXES YOUR ERROR

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAg8Fwp-tffjGczdCJtYqCcO9DYZYSzbXc",
  authDomain: "moeen-2024.firebaseapp.com",
  projectId: "moeen-2024",
  storageBucket: "moeen-2024.firebasestorage.app",
  messagingSenderId: "683595463293",
  appId: "1:683595463293:web:4e579d2dcc6172b7834f14",
  measurementId: "G-RBVGY8JH70"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


// Initialize Firestore
const db = getFirestore(app);

// Export db so I can use it in App.js
export { db };
